import React from 'react';
import PropTypes from 'prop-types';

/**
 * Checkbox component following UI design specifications
 * @param {Object} props - Component props
 * @returns {React.ReactElement} Checkbox component
 */
const Checkbox = ({
  label,
  checked = false,
  onChange,
  disabled = false,
  className = '',
  size = 'medium',
  ...props
}) => {
  // Size styles
  const sizeStyles = {
    small: 'h-3 w-3',
    medium: 'h-4 w-4',
    large: 'h-5 w-5'
  };

  // Base styles
  const baseStyles = `
    ${sizeStyles[size]} text-emerald-600 
    border-gray-300 rounded transition-all duration-200
    focus:ring-emerald-500 focus:ring-2 focus:ring-offset-0
    disabled:opacity-50 disabled:cursor-not-allowed
  `;

  return (
    <div className={`flex items-center ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={baseStyles}
        {...props}
      />
      {label && (
        <label 
          className={`
            ml-2 text-sm text-gray-900 cursor-pointer
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
          onClick={() => !disabled && onChange && onChange({ target: { checked: !checked } })}
        >
          {label}
        </label>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default Checkbox; 